// --------------------------------------------------------------------------
// Status Rendered at top of scanning UI
// --------------------------------------------------------------------------

import React from 'react';
import styles from './index.module.css';
import lookup from './words.js';
/* migrate text from here to words */

// --------------------------------------------------------------------------

class Status extends React.Component {

    // ----------------------------------------------------------------------

    render() {
        
        let statusMessage = this.props.status;
        let statusMessage2 = '';
        let statusData = this.props.statusData;

        switch(this.props.status) {
            
            case 'scanning' :
                statusMessage = lookup('headingScanning');
                statusMessage2 = lookup('textScanning');
                break;

            case 'still scanning' : // been searching for more than 10 seconds
                statusMessage = lookup('headingSuggestSearchInstead');
                statusMessage2 = lookup('textSuggestSearchInstead');
                break;

            case 'validating': // scanned a barcode; currently waiting for APIs to tell us what it is
                statusMessage = lookup('headingScanning');
                statusMessage2 = `Validating ${statusData}`;
                break;

            case 'failure'  : // scanned a barcode, we don't recognise it (either misread or not a wine we support)
                statusMessage = lookup('headingScanning');
                statusMessage2 = lookup('textFailure');
                break;

            case 'skipping' : // scanned a barcode; but we already know this isn't one we care about
                statusMessage = lookup('headingScanning');
                statusMessage2 = lookup('textSkipping');
                break;
            
            case 'no internet':
                statusMessage = lookup('headingNoInternet');//'No internet';
                statusMessage2 = lookup('textNoInternet');//'Please connect to the internet and try again';
                break;
            
            /* states exist but no longer shown - hardcoded for debugging in case shown */
                
            case 'success'  :
                statusMessage = 'Success';
                statusMessage2 = 'Please wait';
                break;

            case 'redirecting':
                statusMessage = 'Redirecting';
                statusMessage2 = 'Please wait...';
                break;
            
        }

        return (
            <div className={styles.bsHeader}>
                <h1>{statusMessage}</h1>
                <p>{statusMessage2}</p>
            </div>
        )

    }

}

// --------------------------------------------------------------------------

export default Status;

// --------------------------------------------------------------------------
